import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="signup-validation"
// Validates the signup form's password fields (plus HTML5 required fields)
export default class extends Controller {
  connect() {
    // Wait for validate plugin to be available
    this.waitForValidate(() => {
      this.initializeValidation()
    })
  }

  waitForValidate(callback) {
    if (window.$ && window.$.fn.validate) {
      callback()
    } else {
      setTimeout(() => this.waitForValidate(callback), 50)
    }
  }

  initializeValidation() {
    window.$(this.element).validate({
      rules: {
        password: {
          minlength: 6,
          maxlength: 20
        },
        passwordconfirmation: {
          required: true,
          equalTo: "#password"
        }
      },
      messages: {
        password: {
          minlength: "Minimum length: 6 characters"
        },
        passwordconfirmation: {
          equalTo: "These passwords don't match."
        }
      }
    })
  }
}
